export enum NotificationType {
  Info = 1,
  Success = 2,
  Error = 3,
}
